<template>
  <div>
    <!-- 新精选课程 -->
    <!-- 以下注释都是联调时需要的 所以暂时保留！ -->
    <li class="dkillItem" @click="goCourseDetail(item)">
      <p class="dkillTitle">
        <i v-if="item.name && item.name.substr(0, 1) == '【'"></i>{{ item.name }}
      </p>
      <!-- <div class="activityTag">
        <TagComponent v-for="(tagItem, tagIndex) in tagType(item)" :key="tagIndex" :text="tagItem" color="yellow-no-bg" />
      </div> -->
      <div class="TimeHours">
        <p class="Time" v-if="item.startTime">
          开课时间<span>{{ item.startTime | changeDeadLineTime }}</span><em>|</em>
        </p>
        <p class="hourse" v-if="item.classPeriod">
          课时<span>{{ item.classPeriod }}</span>
        </p>
      </div>

      <!-- 教师头像 -->
      <ol class="teacherList">
        <ul v-if="item.teacherRespVOS">
          <li v-for="(teacherItem, teaind) in item.teacherRespVOS.length > 3
            ? item.teacherRespVOS.slice(0, 3)
            : item.teacherRespVOS" :key="teaind">
            <div class="teabg">
              <img :src="teacherItem.teacherHead || defaultImg" alt="" />
            </div>
            <p>{{ teacherItem.name }}</p>
          </li>
        </ul>
        <ul v-else>
          <li >
            <div class="teabg">
              <img src="@/assets/img/personalCenter/avator.png" alt="" />
            </div>
            <p></p>
          </li>
        </ul>
        <!-- 售价 -->
        <div class="coursePrice">
          <del v-if="item.originalPrice">￥{{ item.originalPrice }}</del>
          <div class="coursePrice_desc">
            <span class="courseType"
              v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount">拼团价</span>
            <span v-else-if="item.promotionLabel" class="courseType">{{
              item.promotionLabel === 1 ? '折后价' : item.promotionLabel === 4 ? '券后价' : '限时价'
            }}</span>
            <p class="showPic">
              <template v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount">
                <b>¥</b>
                <span>{{ item.productDiscountRespVO.discountMinPrice }}</span>
              </template>
              <template v-else>
                <b v-if="item.sellPrice === 0 && !item.promotionLabel ? false : true">¥</b>
                <span :class="{ fontSty: item.sellPrice === 0 && !item.promotionLabel }">{{
                  item.sellPrice === 0 && !item.promotionLabel ? '限时免费' : item.sellPrice
                }}</span>
              </template>
            </p>
          </div>
        </div>
      </ol>
      <div class="dkillCardBto">
        <p class="endTime">{{ item.salesVolume }}人已购买</p>
        <div class="consultBtn">查看</div>
      </div>
    </li>
  </div>
</template>

<script>
// import TagComponent from '@/components/commonComponents/TagComponent.vue';
import defaultImg from '@/assets/img/loginImg/default.png';
import {
  getTaskApi,
  reqIsBuyProduct,
} from '@/api/member/index';
import { whatEev } from '@/utils/tools';
import wx from 'weixin-js-sdk';

export default {
  components: {
    // TagComponent,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    isUnlock: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultImg,
    };
  },
  computed: {
    tagType() {
      return (val) => {
        const type = [];
        if (val.isUnionDiscount) {
          type.push('联报优惠');
        }
        if (val.isSingleDiscount) {
          type.push('单减活动');
        }
        if (val.isCouponDiscount) {
          type.push('优惠券');
        }
        if (val.productDiscountRespVO && val.productDiscountRespVO.isFullDiscount) {
          type.push('满减活动');
        }
        // 增加购课增好礼标签
        if (val.productDiscountRespVO && val.productDiscountRespVO.isBuyGiftGiveawaysDiscount) {
          type.push('购课赠好礼');
        }
        // 整改暂时注释分期
        /* if (val.huabeiStagingActivity) {
          type.push(`${val.huabeiStagingActivity.maxNumberOfPeriod}期分期免息`);
        } */

        return type;
      };
    },
  },
  methods: {
    // 跳转课程详情
    goCourseDetail(info) {
      const { productId } = info;
      if (this.isUnlock) { // 跳转导学页面
        this.goGuide(productId);
        return;
      }
      // 跳转对应的详情页面
      if (whatEev() === 'miniprogram') {
        let url = window.location.href;
        const { origin } = window.location;
        // eslint-disable-next-line no-unused-vars
        const [domain, searchParams] = url.split('?');
        const params = searchParams.split('&');
        const paramsMap = new Map();
        params.forEach((item) => {
          const [key, value] = item.split('=');
          if (key) {
            paramsMap.set(key, value);
          }
        });
        const entries = paramsMap.entries();
        let query = '';
        const ExcludequeryArr = ['THIRD_SESSION', 'env'];
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of entries) {
          if (ExcludequeryArr.includes(key)) query += `${key}=${value}&beforePageName=8`;
        }
        url = `${origin}/ark/courseDetail?courseId=${productId}&${query}`;
        const path = `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}&isNeedLogin=0`;
        wx.miniProgram.navigateTo({
          url: path,
        });
      } else if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail', Number(productId), false);
      } else {
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: productId,
            beforePageName: 8,
          },
        });
      }
    },
    // 跳转导学页面
    async goGuide(productId) {
      const info = await reqIsBuyProduct(productId);
      if (info.code === 0 && info?.data?.length) {
        const { id } = info?.data?.[0];
        const res = await this.entranceTask(id);
        if (res === 'unFinished') {
          if (this.$root.miniprogram) {
            this.$toast('请前往app完成入学任务后，即可查看课程视频');
          } else if (this.$root.$data.isApp) {
            const { origin } = window.location;
            const url = `${origin}/ark/entranceTask?id=${id}`;
            this.$sendToApp('openNewWebView', { url }, false);
          } else {
            this.$router.push({
              path: '/entranceTask',
              query: {
                id,
              },
            });
          }
        } else if (res === 'finished') {
          if (this.$root.miniprogram) {
            wx.miniProgram.navigateTo({ url: `/myCourse/learningGuide/index?catalogId=${id}` });
          } else if (this.$root.$data.isApp) {
            this.$sendToApp('goDirectoryPage', { courseId: id }, false);
          } else {
            this.$router.push({
              path: '/learningGuide',
              query: {
                catalogId: id,
              },
            });
          }
        }
      }
    },
    async entranceTask(id) {
      const { code, data } = await getTaskApi(id);
      if (code === 0) {
        const {
          agreementId, agreementDone, examId, examDone, examinationFlag, examinationDone,
        } = data;
        this.examId = examId;
        if (
          (agreementId && !agreementDone) || (examId && !examDone) || (examinationFlag && !examinationDone)
        ) {
          return 'unFinished';
        }
        return 'finished';
      }
      return 'err';
    },
  },
  filters: {
    changeDeadLineTime(value) {
      return value.split(' ')[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.dkillItem {
  margin-bottom: 32px;
  padding: 20px 29px 16px 25px;
  background: $bgWhite;
  border-radius: 16px;
  width: 533px;
  height: 312px;
}

.dkillTitle {
  display: block;
  overflow: hidden;
  font-weight: bold !important;
  font-size: 29px;
  font-family: PingFangSC, PingFang SC;
  color: #333333;
  line-height: 40px;
  white-space: nowrap;
  text-overflow: ellipsis;
  // @extend .ellipsis-2;

  // text-overflow: ellipsis;
  // -webkit-line-clamp: 2;
  // -webkit-box-orient: vertical;
  i {
    margin-left: -18px;
  }
}

.activityTag {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin: 9px 5px 11px 0;
  font-size: 0;

  .tag-component {
    margin-right: 14px;
  }
}

.TimeHours {
  display: flex;
  align-items: center;
  line-height: 30px;
  margin-top: 18px;

  p {
    margin-right: 14px;
    color: $fontColorGray;
    font-size: 22px;
  }

  span {
    margin-left: 12px;
    color: $fontColorGray;
    font-size: 22px;
  }

  em {
    margin-left: 12px;
    font-style: normal;
  }
}

.teacherList {
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 29px;

  ul {
    display: flex;

    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 69px;
      // margin-right: 34px;

      .teabg {
        width: 47px;
        height: 44px;
        background-color: $teabg;
        border-radius: 50%;
      }

      img {
        width: 47px;
        height: 44px;
        display: block;
        border-radius: 50%;
      }

      p {
        max-width: 120px;
        margin-top: 9px;
        overflow: hidden;
        color: $fontColorGray;
        font-size: 20px;
        line-height: 28px;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 69px;

        color: #999999;
        text-align: center;
      }
    }
  }
}

.coursePrice {
  position: absolute;
  right: 0;
  bottom: 5px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  &_desc {
    display: flex;
    align-items: baseline;
  }

  del {
    color: $delcolor;
    font-size: 22px;
    margin-bottom: 8px;
  }

  .courseType {
    color: $redColor;
    font-weight: 500;
    font-size: 24px;
  }
}

.showPic {
  margin-left: 6px;
  font-weight: bold;
  font-size: 28px;
  text-align: center;

  b {
    margin: 0 4px;
    color: $redColor;
    font-size: 28px;
  }

  span {
    color: $redColor;
    font-weight: bold;
    font-size: 38px;
  }

  .fontSty {
    font-size: 30px;
  }
}

.dkillCardBto {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 13px;
  padding-top: 20px;
  border-top: 2px solid rgba(151, 151, 151, 0.15);
  zoom: 1;
}

.audition {
  position: absolute;
  top: 0;
  right: -37px;
  display: flex;
  align-items: center;
  padding: 8px 14px 8px 18px;
  color: $liveColor;
  font-weight: 500;
  font-size: 24px;
  background: #fef5f1;
  border-radius: 19px 0 0 19px;

  img {
    width: 14px;
    height: 24px;
    margin-left: 10px;
  }
}

.endTime {
  float: right;
  color: $fontColorGray;
  font-size: 22px;

  span {
    color: $fontColorGray;
    font-size: 22px;
  }
}

.consultBtn {
  width: 128px;
  height: 46px;
  color: #fff;
  font-weight: 400;
  font-size: 24px;
  line-height: 46px;
  text-align: center;
  background: #ff7f41;
  border-radius: 23px;
}
</style>
